/* Pizca · comportamiento del tema */
(function(){
"use strict";

/* ── Paneles laterales ──────────────────────────────────────────────
   El reflow forzado sustituye a requestAnimationFrame: rAF no corre
   con la pestaña en segundo plano y el panel se quedaría fuera de pantalla. */
var velo = document.getElementById("velo");
var abierto = null, ultimoFoco = null;

function abrir(id){
  var p = document.getElementById("panel-" + id);
  if(!p) return;
  ultimoFoco = document.activeElement;
  p.hidden = false;
  void p.offsetWidth;
  p.classList.add("on");
  if(velo) velo.classList.add("on");
  document.body.classList.add("sin-scroll");
  abierto = p;
  var f = p.querySelector("input, button, select, textarea, a[href]");
  if(f) f.focus();
}
function cerrar(){
  if(!abierto) return;
  var p = abierto; abierto = null;
  p.classList.remove("on");
  if(velo) velo.classList.remove("on");
  document.body.classList.remove("sin-scroll");
  setTimeout(function(){ p.hidden = true; }, 350);
  if(ultimoFoco) ultimoFoco.focus();
}
document.addEventListener("click", function(e){
  var t = e.target.closest("[data-panel]");
  if(t){ e.preventDefault(); abrir(t.dataset.panel); return; }
  if(e.target.closest("[data-cerrar]") || e.target === velo) cerrar();
});
document.addEventListener("keydown", function(e){ if(e.key === "Escape") cerrar(); });

/* ── Toast ──────────────────────── */
var toast = document.getElementById("toast"), tid;
function avisar(msg){
  if(!toast) return;
  toast.textContent = msg;
  toast.classList.add("on");
  clearTimeout(tid);
  tid = setTimeout(function(){ toast.classList.remove("on"); }, 2400);
}

/* ── Cuenta de la bolsa ────────────────── */
function pintarCuenta(n){
  document.querySelectorAll("[data-cuenta-bolsa]").forEach(function(el){ el.textContent = n; });
}
function refrescarBolsa(){
  return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js",
               {headers:{"Accept":"application/json"}})
    .then(function(r){ return r.json(); })
    .then(function(c){ pintarCuenta(c.item_count); return c; })
    // fuera de Shopify /cart.js no existe: no dejamos la promesa sin capturar
    .catch(function(){ return null; });
}

/* ── Utilidad: handle igual al filtro `handle` de Liquid ───── */
function handleize(str){
  return (str || "").toString().toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}

/* ── Producto: galería de fotos, filtrada por color y ángulo ─── */
var fotosEls = document.querySelectorAll(".plano [data-foto]");
var miniaturasCont = document.querySelector("[data-miniaturas]");
var miniaturaEls = miniaturasCont ? miniaturasCont.querySelectorAll(".miniatura") : [];

function filtrarGaleria(colorHandle, anguloPreferido){
  if(!fotosEls.length) return;
  var primeraFoto = null, fotoObjetivo = null;
  fotosEls.forEach(function(f){
    var mismoColor = !f.dataset.color || !colorHandle || f.dataset.color === colorHandle;
    f.classList.add("foto--oculta");
    if(mismoColor){
      if(!primeraFoto) primeraFoto = f;
      if(anguloPreferido && f.dataset.angulo === anguloPreferido) fotoObjetivo = f;
    }
  });
  var fotoElegida = fotoObjetivo || primeraFoto;
  if(fotoElegida) fotoElegida.classList.remove("foto--oculta");

  var primeraMini = null, miniObjetivo = null;
  miniaturaEls.forEach(function(m){
    var mismoColor = !m.dataset.color || !colorHandle || m.dataset.color === colorHandle;
    m.classList.toggle("miniatura--oculta", !mismoColor);
    m.setAttribute("aria-pressed", "false");
    m.classList.remove("on");
    if(mismoColor){
      if(!primeraMini) primeraMini = m;
      if(anguloPreferido && m.dataset.angulo === anguloPreferido) miniObjetivo = m;
    }
  });
  var miniElegida = miniObjetivo || primeraMini;
  if(miniElegida){ miniElegida.setAttribute("aria-pressed", "true"); miniElegida.classList.add("on"); }
}

if(miniaturasCont){
  miniaturaEls.forEach(function(b){
    b.addEventListener("click", function(){
      miniaturaEls.forEach(function(x){ x.setAttribute("aria-pressed", "false"); x.classList.remove("on"); });
      b.setAttribute("aria-pressed", "true");
      b.classList.add("on");
      var i = b.dataset.indice;
      fotosEls.forEach(function(f){ f.classList.toggle("foto--oculta", f.dataset.foto !== i); });
    });
  });
}

/* ── Producto: color, talla y variante ───────────────── */
var form = document.querySelector("[data-form-producto]");
if(form){
  var datos = document.getElementById("datos-variantes");
  var variantes = datos ? JSON.parse(datos.textContent) : [];
  var plano = form.closest(".producto") ? form.closest(".producto").querySelector(".plano-svg") : null;
  var campoId = form.querySelector("[name='id']");
  var boton = form.querySelector("[data-agregar]");
  var precioEl = document.querySelector("[data-precio]");

  function seleccion(){
    var sel = {};
    form.querySelectorAll("[data-opcion]").forEach(function(g){
      var b = g.querySelector("[aria-pressed='true']");
      if(b) sel[g.dataset.opcion] = b.dataset.valor;
    });
    return sel;
  }
  function casa(v, sel){
    for(var k in sel){ if(v.opciones[k] !== sel[k]) return false; }
    return true;
  }
  function actualizar(){
    var sel = seleccion(), encontrada = null;
    for(var i=0;i<variantes.length;i++){ if(casa(variantes[i], sel)){ encontrada = variantes[i]; break; } }
    if(encontrada){
      campoId.value = encontrada.id;
      if(precioEl) precioEl.innerHTML = encontrada.precio;
      boton.disabled = !encontrada.disponible;
      boton.textContent = encontrada.disponible ? boton.dataset.textoAgregar : boton.dataset.textoAgotado;
    }else{
      boton.disabled = true;
      boton.textContent = boton.dataset.textoNoDisponible;
    }
    // el dibujo técnico toma el color elegido, y la galería de fotos filtra por el mismo color
    var claveColor = document.getElementById("opcion-color");
    claveColor = claveColor ? JSON.parse(claveColor.textContent) : "color";
    var bc = form.querySelector("[data-opcion='" + claveColor + "'] [aria-pressed='true']");
    if(plano && bc){
      plano.style.setProperty("--prenda", bc.dataset.relleno || "#F1EDE3");
      plano.style.setProperty("--linea", bc.dataset.trazo || "#071A3D");
      var nombre = document.querySelector("[data-color-nombre]");
      if(nombre) nombre.textContent = bc.dataset.valor;
    }
    if(fotosEls.length){
      filtrarGaleria(bc ? handleize(bc.dataset.valor) : null, null);
    }
  }
  form.querySelectorAll("[data-opcion] button").forEach(function(b){
    b.addEventListener("click", function(){
      var g = b.closest("[data-opcion]");
      g.querySelectorAll("button").forEach(function(x){ x.setAttribute("aria-pressed","false"); });
      b.setAttribute("aria-pressed","true");
      actualizar();
    });
  });
  actualizar();

  form.addEventListener("submit", function(e){
    e.preventDefault();
    boton.disabled = true;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
      method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({ id: campoId.value, quantity: 1 })
    }).then(function(r){ return r.json(); })
      .then(function(){ avisar(boton.dataset.textoAgregado); return refrescarBolsa(); })
      .catch(function(){ avisar(boton.dataset.textoError || "Error"); })
      .then(function(){ boton.disabled = false; });
  });
}else if(fotosEls.length){
  // productos sin variantes: igual sincronizamos la galería (sin filtro de color)
  filtrarGaleria(null, null);
}

/* ── Zonas de la prenda: también cambian la foto activa ───── */
var zonas = document.querySelector("[data-zonas]");
if(zonas){
  var ayuda = document.querySelector("[data-zona-texto]");
  var base = ayuda ? ayuda.textContent : "";
  zonas.querySelectorAll("button").forEach(function(b){
    b.addEventListener("click", function(){
      var yaEstaba = b.getAttribute("aria-pressed") === "true";
      zonas.querySelectorAll("button").forEach(function(x){ x.setAttribute("aria-pressed","false"); });
      document.querySelectorAll(".zona").forEach(function(z){ z.classList.remove("on"); });
      if(yaEstaba){ if(ayuda) ayuda.textContent = base; return; }
      b.setAttribute("aria-pressed","true");
      var z = document.getElementById(b.dataset.zona);
      if(z) z.classList.add("on");
      if(ayuda && b.dataset.texto) ayuda.textContent = b.dataset.texto;
      if(fotosEls.length && b.dataset.anguloFoto){
        var formEl = document.querySelector("[data-form-producto]");
        var claveColor = document.getElementById("opcion-color");
        claveColor = claveColor ? JSON.parse(claveColor.textContent) : "color";
        var bc = formEl ? formEl.querySelector("[data-opcion='" + claveColor + "'] [aria-pressed='true']") : null;
        filtrarGaleria(bc ? handleize(bc.dataset.valor) : null, b.dataset.anguloFoto);
      }
    });
  });
}

/* ── Cantidades del carrito ────────────────── */
document.querySelectorAll("[data-cambiar-cantidad]").forEach(function(b){
  b.addEventListener("click", function(){
    var fila = b.closest("[data-linea]");
    var input = fila.querySelector("input[name='updates[]']");
    var v = parseInt(input.value, 10) + parseInt(b.dataset.cambiarCantidad, 10);
    input.value = v < 0 ? 0 : v;
    fila.closest("form").submit();
  });
});

/* ── Filtros de colección ────────────────── */
var filtros = document.querySelector("[data-filtros]");
if(filtros){
  var tarjetas = Array.prototype.slice.call(document.querySelectorAll("[data-rejilla] .ficha"));
  var vacio = document.querySelector("[data-sin-resultados]");
  filtros.querySelectorAll("button").forEach(function(b){
    b.addEventListener("click", function(){
      filtros.querySelectorAll("button").forEach(function(x){ x.setAttribute("aria-pressed","false"); });
      b.setAttribute("aria-pressed","true");
      var f = b.dataset.filtro, visibles = 0;
      tarjetas.forEach(function(t){
        var ok = (f === "todo") || (t.dataset.etiquetas || "").split("|").indexOf(f) !== -1;
        t.hidden = !ok;
        if(ok) visibles++;
      });
      if(vacio) vacio.hidden = visibles > 0;
    });
  });
}

/* ── Popup de bienvenida (10% por correo) ──────────────────
   Se muestra una vez por visitante (localStorage), a los 4 segundos.
   Si el formulario ya se envió con éxito (form.posted_successfully?
   deja data-enviado en el panel), se abre de inmediato mostrando el código. */
var panelDescuento = document.getElementById("panel-descuento");
if(panelDescuento){
  var vistoKey = "pizca_popup_visto";
  var yaVisto = false;
  try { yaVisto = localStorage.getItem(vistoKey) === "1"; } catch(err){}

  function marcarVisto(){
    try { localStorage.setItem(vistoKey, "1"); } catch(err){}
  }

  if(panelDescuento.hasAttribute("data-enviado")){
    marcarVisto();
    setTimeout(function(){ abrir("descuento"); }, 300);
  } else if(!yaVisto){
    setTimeout(function(){ abrir("descuento"); }, 4000);
  }

  panelDescuento.addEventListener("click", function(e){
    if(e.target.closest("[data-cerrar]")) marcarVisto();
  });
  if(velo){
    velo.addEventListener("click", function(){
      if(abierto === panelDescuento) marcarVisto();
    });
  }

  var copiarBtn = panelDescuento.querySelector("[data-copiar-codigo]");
  if(copiarBtn){
    copiarBtn.addEventListener("click", function(){
      var codigo = copiarBtn.dataset.copiarCodigo;
      var hecho = function(){
        var original = copiarBtn.textContent;
        copiarBtn.textContent = copiarBtn.dataset.textoCopiado || "Copiado";
        setTimeout(function(){ copiarBtn.textContent = original; }, 1800);
      };
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(codigo).then(hecho).catch(hecho);
      } else {
        hecho();
      }
    });
  }
}

refrescarBolsa();
})();
